// Typography tokens, aligned with ui/docs/simkura-design.md.
//
// Sizes re-anchored on a 14px tabular base. Old size names preserved for
// back-compat — pages using theme.font.size.md pick up the new 14px body
// automatically (was 16px). The downsizing is intentional: admin density.
//
// Use the ROLES export below for new code so the spec stays the canonical
// source of truth.

export const FONT_FAMILY =
  'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

export const FONT_FAMILY_MONO =
  'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace';

// ── Size scale (rem-anchored) ─────────────────────────────────────────
// Old → New (16px-base → 14px admin-base):
//   xxs  10px → 10px   (unchanged)
//   xs   13.6 → 11px   (now: micro labels, table headers)
//   sm   14.7 → 12px   (now: caption, helper text)
//   md   16   → 14px   (now: body, table rows — the new default)
//   lg   19.7 → 18px   (now: section h2)
//   xl   24.6 → 22px   (now: large heading)
//   xxl  29.6 → 28px   (now: page title)
export const FONT_SIZE = {
  xxs: '0.625rem',  // 10px
  xs:  '0.6875rem', // 11px
  sm:  '0.75rem',   // 12px
  md:  '0.875rem',  // 14px (body base)
  lg:  '1.125rem',  // 18px
  xl:  '1.375rem',  // 22px
  xxl: '1.75rem',   // 28px
};

export const FONT_WEIGHT = {
  regular:  400,
  medium:   500,
  semiBold: 600,
};

export const LINE_HEIGHT = {
  lg: 1.45,  // body / paragraphs
  md: 1.15,  // headings, compact rows
};

// ── Roles ─────────────────────────────────────────────────────────────
// Self-contained per-role specs. New code (and Typography components)
// should pull from ROLES rather than mixing-and-matching size/weight.
export const ROLES = {
  pageTitle: {
    size:       '1.75rem', // 28px
    weight:     600,
    lineHeight: 1.15,
    tracking:   '-0.3px',
  },
  sectionH2: {
    size:       '1.125rem', // 18px
    weight:     600,
    lineHeight: 1.2,
    tracking:   '-0.1px',
  },
  subsection: {
    size:       '0.6875rem', // 11px
    weight:     600,
    lineHeight: 1.1,
    tracking:   '0.6px',
    transform:  'uppercase' as const,
  },
  body: {
    size:       '0.875rem', // 14px
    weight:     400,
    lineHeight: 1.45,
    tracking:   '0',
  },
  bodyTabular: {
    size:       '0.875rem', // 14px
    weight:     400,
    lineHeight: 1.45,
    tracking:   '0',
    features:   '"tnum"',
  },
  caption: {
    size:       '0.75rem', // 12px
    weight:     400,
    lineHeight: 1.4,
    tracking:   '0',
  },
  micro: {
    size:       '0.6875rem', // 11px
    weight:     500,
    lineHeight: 1.1,
    tracking:   '0.4px',
  },
};
